module.exports = __webpack_public_path__ + "static/media/covi_sig_han_was.6b851ff4.png";